import designAreaReducer from '@configuratorware/configurator-frontendgui/App/Reducers/DesignArea/Reducer';
import { RECEIVE_DESIGNER_DATA } from '@configuratorware/configurator-frontendgui/App/Reducers/Configurator/Actions';
import { getDesignDataByDesignAreaIdentifier } from '@configuratorware/configurator-frontendgui/App/Reducers/DesignArea/Selectors';
import get from 'lodash/get';

const query = new URLSearchParams(location.search);
const designSelection = JSON.parse(query.get('_designSelection'));

const filterDesignProductionMethodsByIdentifier = (selectedAreaProductionMethods, productionMethods) => {
  const filteredMethods = [];
  productionMethods.forEach((method) => {
    selectedAreaProductionMethods.map((selectedMethod) => {
      if (selectedMethod.identifier === method.identifier) {
        if (selectedMethod.maxColorAmount) {
          method.options.maxColorAmount = selectedMethod.maxColorAmount;
        }
        filteredMethods.push(method);
      }
    });
  });
  if (filteredMethods.length === 0) {
    throw new Error(`No match with productmethods was found"`);
  } else {
    return filteredMethods;
  }
};

const replaceDesignAreas = (state, codeConfigurationDesignAreas = null) => {
  let filteredDesignAreas = [];
  const designSelectionAreas = codeConfigurationDesignAreas
    ? codeConfigurationDesignAreas
    : designSelection.designAreas;
  state.filteredDesignAreas.forEach((area) => {
    designSelectionAreas.map((selectedArea) => {
      if (selectedArea.identifier === area.identifier) {
        filteredDesignAreas.push({
          ...area,
          designView: {
            ...area.designView,
            designAreas: [
              ...area.designView.designAreas.filter(
                (viewArea) => selectedArea.identifier === viewArea.identifier
              ),
            ],
          },
          designProductionMethods: selectedArea.designProductionMethods
            ? filterDesignProductionMethodsByIdentifier(
                selectedArea.designProductionMethods,
                area.designProductionMethods
              )
            : area.designProductionMethods,
        });
      }
    });
  });
  if (filteredDesignAreas.length === 0) {
    throw new Error(`No match with designarea"`);
  } else {
    return filteredDesignAreas;
  }
};

export default function (state, action) {
  switch (action.type) {
    case RECEIVE_DESIGNER_DATA: {
      const nextState = designAreaReducer(state, action);
      if (nextState.filteredDesignAreas) {
        let newDesignArea = nextState.filteredDesignAreas;
        const { configurator } = action.globalState;
        const { loadCode } = configurator;
        if (designSelection?.designAreas?.length > 0 && nextState.filteredDesignAreas) {
          newDesignArea = replaceDesignAreas(nextState);
        } else if (loadCode) {
          let codeConfigurationDesignAreas = [];
          nextState.filteredDesignAreas.map((designArea) => {
            const designData = getDesignDataByDesignAreaIdentifier(action.globalState, designArea.identifier);
            if (get(designData, 'canvasData.objects.length', 0) > 0) {
              codeConfigurationDesignAreas.push({
                identifier: designArea.identifier,
                designProductionMethods: [{ identifier: designData.designProductionMethodIdentifier }],
              });
            }
          });
          newDesignArea = replaceDesignAreas(nextState, codeConfigurationDesignAreas);
        }
        return {
          ...nextState,
          filteredDesignAreas: newDesignArea,
        };
      }
    }
  }
  return designAreaReducer(state, action);
}
